import * as React from 'react';
import { useIntl } from 'react-intl';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

interface TrainingRunStep1SourceProps {
  onSelectSource: (source: "timeontrails" | "strava" | "manual") => void;
}

const TrainingRunStep1Source: React.FC<TrainingRunStep1SourceProps> = ({ onSelectSource }) => {
  const intl = useIntl();

  return (
    <Box mt={3} display="flex" flexDirection="column" gap={2}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onSelectSource('timeontrails')}
        fullWidth
      >
        {intl.formatMessage({ id: 'trainingRun.source.timeontrailsDesc' })}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onSelectSource('strava')}
        fullWidth
      >
        {intl.formatMessage({ id: 'trainingRun.source.stravaDesc' })}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() => onSelectSource('manual')}
        fullWidth
      >
        {intl.formatMessage({ id: 'trainingRun.source.manualDesc' })}
      </Button>
    </Box>
  );
};

export default TrainingRunStep1Source;
